import { render, staticRenderFns } from "./TabletList.vue?vue&type=template&id=d747262c"
import script from "./TabletList.vue?vue&type=script&lang=js"
export * from "./TabletList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports